import React from 'react';

interface ProgressBarProps {
    value: number;
    color?: string;
}

const ProgressBar: React.FC<ProgressBarProps> = ({ value, color = "#8a00e5" }) => {
    return (
        <div data-testid='progressBar' className="progressBar">
            <div data-testid='progressBar_fill' className="progressBar_fill" style={{ width: `${value}%`, backgroundColor:`${color}` }}></div>
        </div>
    );
};

export default ProgressBar;